import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex: 1;
	overflow: hidden;
	height: 100vh;
`;

export const Application = styled.div`
	flex: 1;
	overflow: hidden;
	position: relative;
	min-width: 0;
`;
